<template>
  <div class="minha-conta" :style="!clienteEncontrado && !loading ? 'height:100vh' : ''">
    <header class="bg-dark py-2">
      <div class="container">
        <div class="row">
          <div class="col">
            <router-link to="/">
              <img src="/img/logo.svg" width="150" height="34" />
            </router-link>
            <span class="badge badge-success ml-2">admin</span>
          </div>
          <div class="col text-right">
            <SideNav />
          </div>
        </div>
      </div>
    </header>

    <div class="bg-gradient">
      <div class="container text-center pt-3">
        <h3>Clientes</h3>
        <div class="h-line" style="width:100px;"></div>
      </div>
    </div>

    <div class="container mt-5 pb-5">
      <b-card class="mb-5 my-card">
        <div class="row my-3 mx-1 justify-content-center">
          <div class="col-md-4 mb-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">E-mail</span>
              </div>
              <input
                type="email"
                class="form-control"
                v-model="email"
                placeholder="email@exemplo.com"
                @keyup.enter="buscar()"
              />
            </div>
          </div>
          <div class="col-md-4 mb-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">CPF</span>
              </div>
              <input
                type="text"
                class="form-control"
                v-mask="'###.###.###-##'"
                v-model="cpf"
                placeholder="000.000.000-00"
                @keyup.enter="buscar()"
              />
            </div>
          </div>
          <div class="col-md-3 mb-2">
            <button
              type="submit"
              class="btn btn-success btn-block"
              @click.prevent="buscar()"
              :disabled="loading"
            >
              <span v-if="!loading">Buscar</span>
              <span v-else>Por favor aguarde...</span>
            </button>
          </div>
        </div>
      </b-card>

      <div class="row">
        <div class="col-lg-12">
          <div class="alert alert-warning text-center" v-if="mensagemErro && !loading">
            {{ mensagemErro }}
          </div>
          <div class="text-center" v-if="buscaRealizada && !clienteEncontrado && !mensagemErro && !loading">
            <p>Nenhum cliente encontrado com a busca realizada.</p>
          </div>

          <div v-if="clienteEncontrado && !loading">
            <b-card class="my-card cliente-card">
              <div class="cliente-card-header">
                <div class="cliente-avatar">
                  {{ iniciais(clienteEncontrado.nome) }}
                </div>
                <div class="cliente-info">
                  <h5 class="cliente-nome">{{ clienteEncontrado.nome }}</h5>
                  <div class="cliente-detalhes">
                    <span class="cliente-detalhe">
                      <span class="detalhe-label">E-mail</span>
                      <span class="detalhe-valor">{{ clienteEncontrado.email }}</span>
                    </span>
                    <span class="cliente-detalhe">
                      <span class="detalhe-label">CPF</span>
                      <span class="detalhe-valor">{{ clienteEncontrado.cpf || '—' }}</span>
                    </span>
                  </div>
                </div>
                <div class="cliente-acoes">
                  <b-dropdown variant="outline-success" no-caret right toggle-class="btn-dots">
                    <template #button-content>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#28a745" viewBox="0 0 16 16">
                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                      </svg>
                    </template>
                    <b-dropdown-item @click="abrirModalExcluir()">
                      <span class="text-danger font-weight-600">Excluir Cliente</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="abrirModalCancelarTransferencia()">
                      Cancelar Transferência
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>

    <Loading :criandoSeguro="true" v-if="loading" />

    <ModalExcluirCliente
      :showModal="showModalExcluir"
      :cliente="clienteParaExcluir"
      @hide="hideModalExcluir"
    />

    <ModalCancelarTransferencia
      :showModal="showModalCancelarTransferencia"
      :email="clienteEncontrado ? clienteEncontrado.email : null"
      @hide="hideModalCancelarTransferencia"
    />
  </div>
</template>

<script>
import SideNav from "../../components/Admin/SideNav";
import Loading from "../../components/Usuario/Loading.vue";
import ModalExcluirCliente from "../../components/Admin/ModalExcluirCliente.vue";
import ModalCancelarTransferencia from "../../components/Admin/ModalCancelarTransferencia.vue";
import config from "../../config";
import auth from "../../auth";
import Swal from "sweetalert2";
import axios from "axios";
import captureError from "../../helpers/captureError";

export default {
  components: {
    SideNav,
    Loading,
    ModalExcluirCliente,
    ModalCancelarTransferencia,
  },
  data() {
    return {
      loading: false,
      email: null,
      cpf: null,
      clienteEncontrado: null,
      buscaRealizada: false,
      showModalExcluir: false,
      clienteParaExcluir: null,
      mensagemErro: null,
      showModalCancelarTransferencia: false,
    };
  },
  created() {
    var userInfo = auth.getUserInfo();
    if (!userInfo || !userInfo.cargo) {
      this.$router.replace("/login");
    }
  },
  methods: {
    async buscar() {
      if (!this.email && !this.cpf) {
        Swal.fire({
          icon: "warning",
          text: "Informe o e-mail ou o CPF do cliente.",
        });
        return;
      }

      this.loading = true;
      this.clienteEncontrado = null;
      this.buscaRealizada = false;
      this.mensagemErro = null;

      try {
        let cliente = null;

        if (this.email) {
          const response = await axios.get(
            `${config.API_URLV2}/cliente/buscarPeloEmail/${encodeURIComponent(this.email)}`
          );
          cliente = response.data;
        } else if (this.cpf) {
          const cpfLimpo = this.cpf.replace(/\D/g, "");
          const response = await axios.get(
            `${config.API_URLV2}/cliente/BuscarClientePeloCpf/${cpfLimpo}`
          );
          cliente = response.data;
        }

        if (cliente && (cliente.nome || cliente.email || cliente.cpf)) {
          this.clienteEncontrado = cliente;
        }
      } catch (error) {
        const apiData = error.response && error.response.data;
        const erroApi = apiData && Array.isArray(apiData.erros) && apiData.erros[0];
        if (erroApi) {
          this.mensagemErro = erroApi;
        } else if (error.response && error.response.status === 404) {
          this.mensagemErro = null; // buscaRealizada exibirá "Nenhum cliente encontrado"
        } else {
          captureError(error);
          this.mensagemErro = "Não foi possível realizar a busca. Tente novamente mais tarde.";
        }
      } finally {
        this.loading = false;
        this.buscaRealizada = true;
      }
    },

    abrirModalExcluir() {
      if (!this.clienteEncontrado) return;
      this.clienteParaExcluir = {
        nomeCliente: this.clienteEncontrado.nome,
        emailCliente: this.clienteEncontrado.email,
        cpfCliente: this.clienteEncontrado.cpf,
      };
      this.showModalExcluir = true;
    },

    hideModalExcluir() {
      this.showModalExcluir = false;
      this.clienteParaExcluir = null;
      this.clienteEncontrado = null;
      this.buscaRealizada = false;
      this.email = null;
      this.cpf = null;
    },

    abrirModalCancelarTransferencia() {
      if (!this.clienteEncontrado) return;
      this.showModalCancelarTransferencia = true;
    },

    hideModalCancelarTransferencia() {
      this.showModalCancelarTransferencia = false;
    },

    iniciais(nome) {
      if (!nome) return '?';
      const partes = nome.trim().split(' ');
      if (partes.length === 1) return partes[0][0].toUpperCase();
      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");

.my-card {
  border-radius: 12px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
  background-color: #fff;
  color: #252422;
  margin-bottom: 20px;
  position: relative;
  border: 0;
}

.minha-conta {
  background: #f4f3ef;
  min-height: 100vh;
}

.bg-gradient {
  background: #fff;
  padding: 20px 0 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.cliente-card {
  padding: 8px 0;
}

.cliente-card-header {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.cliente-avatar {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 50%;
  background: #28a745;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
}

.cliente-info {
  flex: 1;
}

.cliente-nome {
  margin: 0 0 8px;
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
}

.cliente-detalhes {
  display: flex;
  gap: 28px;
  flex-wrap: wrap;
}

.cliente-detalhe {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detalhe-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888;
  font-weight: 600;
}

.detalhe-valor {
  font-size: 14px;
  color: #333;
}

.cliente-acoes {
  margin-left: auto;
}

.btn-excluir {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  padding: 8px 18px;
  border-radius: 8px;
  white-space: nowrap;
}

.btn-dots {
  border: 1.5px solid #28a745 !important;
  border-radius: 6px !important;
  padding: 5px 10px !important;
  color: #28a745;
  background: transparent;
  text-decoration: none;
}

.btn-dots:hover {
  background: #28a745 !important;
}

.btn-dots:hover svg {
  fill: #fff;
}

.icone-excluir {
  font-size: 15px;
}

.h-line {
  height: 3px;
  background: #28a745;
  margin: 6px auto 0;
  border-radius: 2px;
}
</style>
